import {createAvatarComponent, SrcSource, ValueSource} from "react-avatar";


export const UniCatAvatar = createAvatarComponent({
    sources: [ SrcSource, ValueSource ]
});